<script setup lang="ts">
import RegisterSignInView from '../../views/RegisterSignInView/RegisterSignInView.vue';
import { useQuasar } from 'quasar';
import UserAuthPageDecoration from 'src/shared/components/UserAuthPageDecoration/UserAuthPageDecoration.vue';

const $q = useQuasar();
$q.dark.set(true);

// interface Props {
//   // modelValue: string
// }

// defineProps<Props>()
</script>

<template>
  <q-page
    padding
    class="column bg-dark"
  >
    <RegisterSignInView class="row fit items-center justify-center relative" />
    <UserAuthPageDecoration />
  </q-page>
</template>
